import React from "react";
import {
  Drawer,
  Button,
  Space,
  Row,
  Col,
  Card,
  Form,
  Input,
  Upload,
  message,
  Typography,
  Flex,
} from "antd";
import UploadDocIcon from "../../../../../../../Theme/CustomIcons/Icons/ContentEdit/UploadDocIcon";
import ThemeSettingsPopup from "../../../../../../../Global/Settings/Component/ThemeSettingsPopup";
const { Dragger } = Upload;
const { Text } = Typography;

const ThemeSelectionDrawer = ({ open, onClose, entityId }) => {
  const [form] = Form.useForm();

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      console.log("Saving theme details for entity:", entityId, values);
      onClose();
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  // ✅ Upload component config
  const uploadProps = {
    name: "file",
    multiple: true,
    action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <Drawer
      title="Theme Settings"
      open={open}
      onClose={onClose}
      width="100%"
      destroyOnClose
      footer={
        <Space
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleSave}>
            Save Details
          </Button>
        </Space>
      }
    >
      <Row justify="center">
        <Col span={12}>
          <Form
            form={form}
            layout="vertical"
            initialValues={{
              companyName: "",
              primaryColor: "#1890ff",
              secondaryColor: "#52c41a",
              themeMode: "light",
            }}
          >
            <Row gutter={[16, 16]}>
              {/* Brand Settings */}
              <Col span={12}>
                <Card title="Brand Settings" style={{ height: 500 }}>
                  <Form.Item
                    label="Company Name"
                    name="companyName"
                    rules={[
                      { required: true, message: "Please enter company name" },
                    ]}
                  >
                    <Input placeholder="Enter company name" />
                  </Form.Item>

                  <Form.Item label="Company Tagline" name="companyTagline">
                    <Input placeholder="Enter company tagline" />
                  </Form.Item>

                  <Form.Item label="Upload Company Logo" name="companyLogo">
                    <Dragger {...uploadProps}>
                      <Flex
                        vertical
                        align="center"
                        gap={8}
                        justify="center"
                        style={{ height: 125 }}
                      >
                        <UploadDocIcon size="small" />
                        <Text style={{ fontSize: 16, fontWeight: 400 }}>
                          Drag & Drop to upload logo or{" "}
                          <span
                            style={{
                              fontWeight: 700,
                              textDecoration: "underline",
                            }}
                          >
                            Browse
                          </span>
                        </Text>
                      </Flex>
                    </Dragger>
                  </Form.Item>
                </Card>
              </Col>

              {/* Theme Settings */}
              <Col span={12}>
                <Card style={{ padding: 0, height: 500 }}>
                  <ThemeSettingsPopup viewThemeSettings={open} />
                </Card>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Drawer>
  );
};

export default ThemeSelectionDrawer;
